import { breakpoints } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import IconButton from '@bnnvara/buttons/src/components/IconButton/styled';
import styled from 'styled-components';

import appConfig from '../../config/app.json';

export const HubContainer = styled.section`
  position: sticky;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: ${appConfig.layout.hubHeight}px;
  background: ${({ solid, theme }) =>
    solid ? theme.base.black : theme.gradient.primary};
  transition: background 300ms ease-in-out;

  ${breakpoints.md} {
    height: ${appConfig.layout.hubHeightMd}px;
  }
`;

export const Separator = styled.span`
  display: inline-block;
  height: 20px;
  margin: 0 12px;
  border-right: 1px solid ${({ theme }) => theme.secondary.light};
  opacity: 0.8;

  ${breakpoints.md} {
    margin: 0 16px;
  }

  ${breakpoints.lg} {
    margin: 0 16px;
  }
`;

export const NPOIcon = styled.img.attrs({
  alt: 'NPO',
  src: '/static/icons/npo.svg',
})`
  width: 32px;
  height: 32px;
`;

export const SearchButton = styled(IconButton)`
  width: 24px;
  height: 24px;

  ${breakpoints.md} {
    width: 32px;
    height: 32px;
  }
`;

export const MenuButton = styled(BaseButton)`
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.base.white};

  &:after {
    display: none;
  }

  svg {
    display: none;
  }

  ${breakpoints.md} {
    svg {
      display: block;
      width: 16px;
      height: 28px;
    }
  }
`;

export const LogoLink = styled.a`
  margin-left: -2px;
`;

export const MemberContainer = styled.span`
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.primary.main};
  border-radius: 50%;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${({ theme }) => theme.primary.light};
    transition: all 0.2s ease-in-out;
  }

  ${breakpoints.md} {
    display: inline-block;
    border-radius: 0;
    width: auto;
    height: auto;
    padding: 0 44px;

    svg {
      display: none;
    }
  }

  @keyframes fade {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    97% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  span {
    position: absolute;
    margin-top: 42px;
    background: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    padding: 8px 16px;
    color: ${({ theme }) => theme.base.black};
    font-weight: 700;
    font-size: 14px;
    animation: fade 8s;
    font-size: 12px;
    opacity: 0;

    &:after {
      content: '';
      width: 15px;
      z-index: -1;
      height: 15px;
      display: block;
      position: absolute;
      top: -4px;
      background: #fff;
      left: 50%;
      transform: translateX(-50%) rotate(-45deg);
    }

    ${breakpoints.md} {
      position: relative;
      margin-top: 0;
      animation: none;
      opacity: 1;
      background: transparent;
      box-shadow: none;
      color: ${({ theme }) => theme.base.white};
      font-size: 14px;
      line-height: 40px;
      padding: 0;

      &:after {
        display: none;
      }
    }
  }
`;

export default HubContainer;
